var _image;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBurgerBlue = function SvgBurgerBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 213,
    height: 213,
    viewBox: "0 0 213 213"
  }, props), _image || (_image = /*#__PURE__*/React.createElement("image", {
    x: 2,
    y: 2,
    width: 209,
    height: 209,
    xlinkHref: "data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAANEAAADRBAMAAACgFErcAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAElBMVEX///8AAAAYl/D///8Yl/AAAAB5Hx4aAAAAA3RSTlMAAAD6dsTeAAAAAWJLR0QB/wIt3gAAAAlwSFlzAAAuIwAALiMBeKU/dgAAAAd0SU1FB+MGFQUQFOJQlUYAAACYSURBVHja7dhBDYBQDETBLwEsoOAnGCAE/5ow0fbQzjMw5911F7UXiUSKlfbKjUQikUgkEolEIpFypbr9RCKRYqSzqINEIpFIJBKJRCKRUqSOS41EmiF1fEdJJBKJRCKRSCTSJKluP5FIpBip4ztKIpFIJBKJRCKRJklfUQ+JRAqW3is3EolEIpFIJBKJRMqV6vYTiUQKkX5vpOm5ZfBO3QAAAABJRU5ErkJggg=="
  })));
};
export default SvgBurgerBlue;